import dayjs from 'dayjs';

import { Project } from '../../types';

import { ReactComponent as Hourglass } from '../../resources/icons/hourglass.svg';
import { ReactComponent as Location } from '../../resources/icons/location.svg';
import { ReactComponent as Squared } from '../../resources/icons/squared_cube.svg';
import { ReactComponent as Rooms } from '../../resources/icons/rooms.svg';
import { ReactComponent as Calendar } from '../../resources/icons/calendar.svg';
import { ReactComponent as CalendarCheck } from '../../resources/icons/calendar_check.svg';
import { ReactComponent as Cancel } from '../../resources/icons/cancel.svg';
import { useCallback } from 'react';

interface Props {
  project: Project;
}

const ProjectDataSection = ({ project }: Props) => {
  const renderDetail = useCallback(
    (
      Icon: React.FunctionComponent<
        React.SVGProps<SVGSVGElement> & {
          title?: string;
        }
      >,
      title: string,
      value: string | number
    ) => {
      return (
        <div className="mb-4">
          <p className="text-[#344054] mb-2 font-semibold">{title}</p>
          <div className="flex items-start">
            <Icon className="w-4 h-4 mr-1" />
            <p className="-mt-[2px]">{value}</p>
          </div>
        </div>
      );
    },
    []
  );

  return (
    <div className="text-sm bg-[#F9FAFB] rounded-lg p-6 w-[24rem] h-fit">
      {project.status !== 'DRAFT' && (
        <div className="grid grid-cols-2 gap-x-4">
          {renderDetail(
            Calendar,
            'Published date',
            dayjs(project.publishedAt).format('DD.MM.YYYY')
          )}
          {project.status === 'COMPLETED' &&
            renderDetail(
              CalendarCheck,
              'Completion date',
              dayjs(project.closedAt).format('DD.MM.YYYY')
            )}
          {project.status === 'CANCELLED' &&
            renderDetail(
              Cancel,
              'Cancellation date',
              dayjs(project.closedAt).format('DD.MM.YYYY')
            )}
        </div>
      )}
      <div className="grid grid-cols-2 gap-x-4">
        {renderDetail(
          Hourglass,
          'Execution plan',
          `${project.executionMonths} months`
        )}
        {renderDetail(Location, 'Location', project.address)}
        {renderDetail(Squared, 'Square meters', project.squareMeters)}
        {renderDetail(Rooms, 'Rooms', project.rooms)}
      </div>
    </div>
  );
};

export default ProjectDataSection;
